/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Feature_Page_TitleInputs */

const en_platform_feature_page_title = /** @type {(inputs: Platform_Feature_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your own public page`)
};

const pl_platform_feature_page_title = /** @type {(inputs: Platform_Feature_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoja własna strona`)
};

/**
* | output |
* | --- |
* | "Your own public page" |
*
* @param {Platform_Feature_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_feature_page_title = /** @type {((inputs?: Platform_Feature_Page_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Feature_Page_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_feature_page_title(inputs)
	return en_platform_feature_page_title(inputs)
});